export const MIN_FINDING_HIGH_SCORE = 3;

export const DEFAULT_QUESTION = {
  ENDOMETRIAL_THICKNESS: 'default_question_endometrial_thickness',
} as const;

export const FINDING_CONDITION_TEMPLATE = {
  OTHER: 'other',
} as const;

export const SPONDYLOARTHROPATHY_CONDITION = 'spondyloarthropathy' as const;

export const POST_MENOPAUSAL_FIELD = 'post_menopausal';

export const POST_MENOPAUSAL_CONDITION = 'default_question_post_-_menopausal_status';
